export default "__VITE_ASSET__pQZd2Ms7__"